export default __webpack_public_path__ + "static/ai-marketing-3--mobile-f93bf03182c2c1b3c8be1283c5bd2520.png";